import React from "react";


class reportsRenderParams extends React.Component {
  

  RenderMain = (props) => {
    if (props?.itm) {
      const { idx, itm } = props;
      switch (itm.inputType) {
        case "form-control":
          return (
            <props.Bs
              formcontrol
              type={this.props.selectedReports.params[idx].typeOf}
              min={this.props.selectedReports.params[idx].min}
              max={this.props.selectedReports.params[idx].max}
              maxLength={this.props.selectedReports.params[idx].length}
              value={this.props.selectedReports.params[idx].value}
              isValid={this.props.selectedReports.params[idx].validate}
              placeholder={this.props.selectedReports.params[idx].placeholder}
              isInvalid={!this.props.selectedReports.params[idx].validate}
              onChange={(e) => {
                let prm = this.props.selectedReports.params;
                prm[idx] = { ...prm[idx], value: e.target.value };
                this.props.setState({ params: prm });
              }}
            />
          );
        case "form-select-multi": case "form-select":
          return (
            <props.Bs
              brtxselect
              options={this.props.selectedReports.params[idx].optionsData}
              isMulti={itm.inputType === "form-select-multi" ? true : false}
              value={this.props.selectedReports.params[idx].value}
              placeholder={this.props.selectedReports.params[idx].placeholder}
              isValid={this.props.selectedReports.params[idx].validate}
              isInvalid={!this.props.selectedReports.params[idx].validate}
              onChange={(e) => {
                let prm = this.props.selectedReports.params;
                prm[idx] = { ...prm[idx], value: e };
                this.props.setState({ params: prm });
              }}
            />
          );
        default:
          return null;
      }
    }
  };

  render() {
    const { Bs, VARIANT, SIZE, selectedReports } = this.props;
    return (
      <Bs card bg={VARIANT.UNI} className="mt-4">
        <Bs cardbody>
          <Bs row className="mb-2">
            <Bs strong>Parametry</Bs>
          </Bs>
          <Bs row>
            {selectedReports?.params?.map((itm, idx) => (
              <Bs col xs={12} md={6} lg={4}>
                <this.RenderMain {...this.props} itm={itm} idx={idx} />
                <Bs formtext className="mb-2">
                  {itm.label}
                </Bs>
              </Bs>
            ))}
          </Bs>
        </Bs>
      </Bs>
    );
  }
}

export default reportsRenderParams;
